module.exports = {
	custom: {
		insertFile: "Выбор файла",
		insertNewFile: "Выберите файл",
		add: "Добавить",
		delete: "Удалить",
		edit: "Изменить",
		deleteDialog: {
			message: "Уверены, что хотите удалить?",
			cancel: "Отмена",
		},
		table: {
			thumb: "Превью",
			name: "Название",
			size: "Размер",
			tags: "Тэги",
			action: {
				action: "Действие",
				deleteTooltip: "Удалить",
			},
		},
		size: {
			kb: "KB",
			mb: "MB",
		},
		maxFileSizeAlert: "Максимальный размер файла",
		maxFileCountAlert: "Максимальное количество файлов",
		fileName: "Название",
		fileDescription: "Описание",
		fileTags: "Тэги",
	},
};
